<div class="p-grid">
	<div class="p-col-12 lg:p-col-12 d-flex flex-column">
		<div *ngFor="let field of orderType.ooOrderTypeFields; let idx = index" class="mb-3 d-flex">
			<input pInputText class="w-100" (change)="changesToSaveChange.emit(true)" type="text" [(ngModel)]="field.key" />
			<p-button pRipple styleClass="p-button-raised p-button-danger m-2" (click)="orderType.ooOrderTypeFields.splice(idx, 1)">
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'trash']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>

			<p-checkbox
				(onChange)="changesToSaveChange.emit(true)"
				name="required"
				binary="true"
				[(ngModel)]="field.required"
				label="Required"
				labelStyleClass="mt-2"
				styleClass="ms-4"
			></p-checkbox>
		</div>
		<div class="btn btn-primary w-100 mb-3" (click)="orderTypeFieldAdd()">Add Field</div>
	</div>
</div>
